// Shared formatting utilities

/**
 * Format amount as CHF currency string (no decimals)
 * @param {number} amount
 * @returns {string} e.g. "CHF 1'234"
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("de-CH", {
    style: "currency",
    currency: "CHF",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

/**
 * Format amount as plain CHF number (no currency symbol, no decimals)
 * @param {number} amount
 * @returns {string} e.g. "1'234"
 */
export const formatCHF = (amount) => {
  return new Intl.NumberFormat("de-CH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
};
